/**
 * @description
 * Objeto PersonsByIdNumCtrlDig
 */

export class Representants {
    
    public codi: string;
    public nif: string;
    public nom: string;
    public cognom1: string;
    public cognom2: string;
    public nomcomplet: string;
    public telf1: string;
    public carreccodi: string;
    public carrecnom: string;
    public entitatcodi: string;
    public entitatcif: string;
    public entitatnom: string;
    public entitatdboid: string;
  
    constructor() {}
  
}